import CrmBalanceAPI from '../../../../../api/crm/CrmBalanceAPI.js';
import notifyError from '../../../../procedures/notify-error.js';
import notifySuccess from '../../../../procedures/notify-success.js';

export default {
  label: 'Wyślij wezwania do zapłaty',
  icon: 'icon-send',
  handle: async ({ $vs }) => {
    $vs.loading();

    CrmBalanceAPI.sendAllPaymentReminderMail()
      .then(() => {
        notifySuccess({
          $vs,
          text: 'Wiadomości zostały wysłane',
        });
      })
      .catch(() => {
        notifyError({
          $vs,
          text: 'Nie udało się wysłać wiadomości',
        });
      })
      .finally(() => $vs.loading.close());
  },
};
